import { lazy, Suspense } from 'react';
import { Outlet, Navigate } from 'react-router-dom';

import DashboardLayout from 'src/layouts/dashboard';
import { AuthGuard, OwnerGuard } from 'src/auth/guard';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const AccrualPage = lazy(() => import('src/pages/billing/accrual'));

// Owner billing area (#59). Read-only mid-month accrual for the agency owner. Gated by OwnerGuard
// (owner role only) on top of AuthGuard; the backend `read:billing` policy is the real authority.
export const billingRoutes = [
  {
    path: 'billing',
    element: (
      <AuthGuard>
        <OwnerGuard>
          <DashboardLayout>
            <Suspense fallback={<LoadingScreen />}>
              <Outlet />
            </Suspense>
          </DashboardLayout>
        </OwnerGuard>
      </AuthGuard>
    ),
    children: [
      { element: <Navigate to="accrual" replace />, index: true },
      { path: 'accrual', element: <AccrualPage /> },
    ],
  },
];
